import React, { Component } from 'react'
import store from 'store2'
import intlTelInput from 'intl-tel-input'

export default class PhoneInput extends Component {
  constructor(props) {
    super(props)
    this.inputRef = React.createRef()

    this.state = {
      value: props.value
    }
  }

  componentDidMount() {
    this.phoneField = intlTelInput(this.inputRef.current, {
      preferredCountries: [
        'us', 'gb', 'de', 'ch'
      ],
      geoIpLookup: function(callback) {
        callback(store.session('diviac.countryCode') || 'US')
      },
      initialCountry: 'auto',
      utilsScript: `${window.staticPath}phone-utils/phone-utils.js`
    })

    if (this.props.getPhoneInstance) {
      this.props.getPhoneInstance(this.phoneField)
    }
  }

  changeHandler = (value) => {
    this.setState({
      value
    })

    this.props.onChange(this.phoneField.getNumber())
  }

  render() {
    return (<input ref={this.inputRef} value={this.state.value} placeholder={this.props.placeholder} onChange={(e) => this.changeHandler(e.target.value)} />)
  }
}
